import React, { useEffect } from 'react';

const Darkmode = () => {
  // Set light theme as default when page loads
  useEffect(() => {
    document.body.classList.add('light');
  }, []);

  // Function to toggle theme
  const switchTheme = () => {
    document.body.classList.toggle('light');
  };

  return (
    <button id="darkmode" onClick={switchTheme}>
      <img
        className="light-icon"
        src={`${process.env.PUBLIC_URL}/images/icons/sun-01.svg`}
        alt="Light Mode"
      />
      <img
        className="dark-icon"
        src={`${process.env.PUBLIC_URL}/images/icons/vector.svg`}
        alt="Dark Mode"
      />
    </button>
  );
};

export default Darkmode;
